export default class AccountGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onAddSuccess(accountDto) {}

  onAddError(error) {}
}
